export type LogContext = Record<string, unknown>;

export interface ContextProvider {
  getStore(): LogContext | undefined;
  run<T>(context: LogContext, fn: () => T): T;
}

let provider: ContextProvider = {
  // eslint-disable-next-line unicorn/no-useless-undefined -- two conflicting rules: no-useless-undefined vs no-useless-return; explicit undefined is clearest
  getStore: () => undefined,
  run: <T>(_ctx: LogContext, fn: () => T): T => fn(),
};

export function getProvider(): ContextProvider {
  return provider;
}

export function setContextProvider(p: ContextProvider): void {
  provider = p;
}
